import type { CSSProperties, ReactElement } from 'react';

const containerStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 0,
  pointerEvents: 'none',
  overflow: 'hidden',
  background: 'var(--bg, #f0f2f5)',
};

export function GradientMesh(): ReactElement {
  return (
    <div aria-hidden="true" style={containerStyle}>
      {/* Large top-left blue wash */}
      <div
        style={{
          position: 'absolute',
          width: '80vw',
          height: '80vh',
          top: '-30vh',
          left: '-20vw',
          background:
            'radial-gradient(ellipse at center, var(--mesh-color-1, rgba(49,120,183,0.15)) 0%, transparent 70%)',
        }}
      />
      {/* Large bottom-right cyan wash */}
      <div
        style={{
          position: 'absolute',
          width: '70vw',
          height: '70vh',
          bottom: '-25vh',
          right: '-15vw',
          background:
            'radial-gradient(ellipse at center, var(--mesh-color-2, rgba(6,182,212,0.12)) 0%, transparent 70%)',
        }}
      />
      {/* Mid-center blue glow */}
      <div
        style={{
          position: 'absolute',
          width: '50vw',
          height: '50vh',
          top: '25%',
          left: '35%',
          background:
            'radial-gradient(ellipse at center, var(--mesh-color-3, rgba(49,120,183,0.08)) 0%, transparent 65%)',
        }}
      />
      {/* Upper-right cyan accent */}
      <div
        style={{
          position: 'absolute',
          width: '40vw',
          height: '40vh',
          top: '-5%',
          right: '5%',
          background:
            'radial-gradient(ellipse at center, var(--mesh-color-2, rgba(6,182,212,0.10)) 0%, transparent 65%)',
        }}
      />
    </div>
  );
}
